import {ImagePositioningRestDto} from "@/api/pharma-cms-content-block/models";
import {ObjectFitEnum} from "@/api/enums/object-fit-enum";
import {PositionHorizontalEnum} from "@/api/enums/position-horizontal-enum";
import {PositionVerticalEnum} from "@/api/enums/position-vertical-enum";

export class ImagePositioningRestDtoModel implements ImagePositioningRestDto {
    object_fit_code: ObjectFitEnum;
    position_horizontal_code?: PositionHorizontalEnum | null;
    position_vertical_code?: PositionVerticalEnum | null;

    constructor(object_fit_code: ObjectFitEnum) {
        this.object_fit_code = object_fit_code;
    }

    static createWithDefaults(): ImagePositioningRestDtoModel {
        return new this(ObjectFitEnum.AUTO);
    }

    static cloneFrom(source: ImagePositioningRestDto): ImagePositioningRestDtoModel {
        const clone: ImagePositioningRestDtoModel = new this(source.object_fit_code);

        clone.position_horizontal_code = source.position_horizontal_code;
        clone.position_vertical_code = source.position_vertical_code;

        return clone;
    }
}
